import { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { useHistory } from 'react-router-dom'
import CookiesStorageService from '../../../services/CookiesStorageService'
import { ReactComponent as AdminIcon } from '../../../images/admin-modules.svg'
import { ReactComponent as CoreIcon } from '../../../images/core-modules.svg'
import { ReactComponent as RecIcon } from '../../../images/recruitment-modules.svg'
import { ReactComponent as EdsIcon } from '../../../images/eds-modules.svg'
import { ReactComponent as SelfIcon } from '../../../images/self-service.svg'
import { ReactComponent as OtmsIcon } from '../../../images/core-module-icon.svg'
import AppRoutes from '../../../services/AppRoutes'

const Index = () => {
  const history = useHistory()

  const [userModules, setUserModules] = useState(null)

  useEffect(() => {
    setUserModules(CookiesStorageService.getUserModules())
  }, [])

  const changeModuleIconBasedOnCode = (moduleCode) => {
    switch (moduleCode) {
      case 'admin':
        return <AdminIcon />
      case 'recruitment':
        return <RecIcon />
      case 'eds':
        return <EdsIcon />
      case 'self':
        return <SelfIcon />
      case 'otms':
        return <OtmsIcon />
      default:
        return <CoreIcon />
    }
  }

  const redirectToSelectedModuleHandler = (moduleCode) => {
    if (moduleCode === 'eds') {
      window.location.href = process.env.REACT_APP_EDS_FRONTEND_URL
    } else if (moduleCode === 'recruitment') {
      window.location.href = process.env.REACT_APP_RECRUITMENT_FRONTEND_URL
    } else if (moduleCode === 'self') {
      window.location.href = `${process.env.REACT_APP_SELF_FRONTEND_URL}`
    } else if (moduleCode === 'core') {
      window.open(`${process.env.REACT_APP_CORE_FRONTEND_URL}/`, '_blank')
    } else if (moduleCode === 'admin') {
      history.push(AppRoutes.home)
    }
  }

  return (
    <Box sx={styles.root}>
      {(userModules)?.map((singleModule) => (
        <Box key={singleModule.code} sx={styles.singleModuleBtn}
             onClick={() => redirectToSelectedModuleHandler(singleModule.code)}>
          <Box sx={styles.moduleIcon}>
            {changeModuleIconBasedOnCode(singleModule.code)}
          </Box>
          <Typography>{singleModule.name}</Typography>
        </Box>
      ))}
    </Box>
  )
}

const styles = {
  root: {
    border: '1px solid #E2E8EE',
    borderRadius: '12px',
    overflow: 'hidden',
  },

  singleModuleBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: { xs: '17px', sm: '28px 17px' },
    cursor: 'pointer',
    borderBottom: '1px solid #E2E8EE',
    transition: 'all 0.3s ease',
    '& p': {
      width: '100%',
      textAlign: 'center',
      fontSize: { xs: '12px', sm: '16px' },
      color: '#92929D',
    },
    '&:hover': {
      borderColor: '#29cc8b',
      color: '#29cc8b',
      '& p': {
        color: '#29cc8b',
      },
      '& svg': {
        fill: '#29cc8b',
      },
      '& path': {
        fill: '#29cc8b',
      },
      '& g': {
        fill: '#29cc8b',
      },
    },
  },
  moduleIcon: {
    '& svg': {
      width: { xs: '20px', sm: '30px' },
      height: { xs: '20px', sm: '30px' },
      fill: '#828282',
      '& g': {
        fill: '#828282',
      },
    },
  },
}
export default Index
